import React from 'react';
import RawGenericDatePicker from '../generic-date-picker/RawGenericDatePicker';

function RawTimePicker({disabled, nonePrefix, onChange, selected, label, tabIndex}) {
    return (
        <div>
            <RawGenericDatePicker
                label={label}
                showTimeSelectOnly
                showTimeSelect={true}
                dateFormat={'HH:mm'}
                disabled={disabled}
                onChange={onChange}
                selected={selected}
                tabIndex={tabIndex}
                nonePrefix={nonePrefix}
            />
        </div>
    );
}

export {RawTimePicker};
